var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8544 0H2.13238C0.954696 0 0 0.954696 0 2.13238V37.8574C0 39.0351 0.954696 39.9898 2.13238 39.9898H61.8544C63.032 39.9898 63.9867 39.0351 63.9867 37.8574V2.13238C63.9867 0.954696 63.032 0 61.8544 0Z",
    fill: "#F1F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5845 39.9951H61.8492C63.0276 39.9951 63.9816 39.0411 63.9816 37.8627V22.8901C59.7321 25.5837 43.7138 34.8682 17.5845 40.0002V39.9951Z",
    fill: "#F58220"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7714 16.8804C31.0063 16.8804 29.5779 18.2577 29.5779 19.9565C29.5779 21.7624 30.9451 23.1143 32.7714 23.1143C34.5977 23.1143 35.9546 21.7471 35.9546 19.9922C35.9546 18.2373 34.5568 16.8804 32.7714 16.8804Z",
    fill: "url(#paint0_radial_4583_263182)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6462 16.9927H12.9321V22.9817H14.6411C15.5492 22.9817 16.2021 22.7675 16.7786 22.293C17.4622 21.7268 17.8652 20.8748 17.8652 19.9923C17.8652 18.2272 16.5439 16.9927 14.6513 16.9927H14.6462ZM16.0134 21.4921C15.6461 21.8237 15.1717 21.9665 14.4115 21.9665H14.0953V18.0079H14.4115C15.1666 18.0079 15.6257 18.1405 16.0134 18.4925C16.4164 18.8547 16.6562 19.4056 16.6562 19.9821C16.6562 20.5586 16.4164 21.135 16.0134 21.4921Z",
    fill: "#001722"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.564 16.9927H18.3958V22.9817H19.564V16.9927Z",
    fill: "#001722"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4208 19.2881C21.7168 19.0279 21.5127 18.8596 21.5127 18.5331C21.5127 18.1556 21.88 17.8699 22.385 17.8699C22.737 17.8699 23.0227 18.0127 23.3288 18.3545L23.941 17.5587C23.4359 17.1149 22.834 16.8955 22.181 16.8955C21.125 16.8955 20.3139 17.6301 20.3139 18.6096C20.3139 19.436 20.6914 19.8594 21.7882 20.2522C22.2473 20.4155 22.482 20.5226 22.5942 20.594C22.8289 20.7471 22.9462 20.9613 22.9462 21.2113C22.9462 21.6959 22.5585 22.053 22.0382 22.053C21.4821 22.053 21.0332 21.7775 20.7628 21.2572L20.0078 21.9867C20.5435 22.7774 21.1913 23.1243 22.079 23.1243C23.2931 23.1243 24.145 22.3132 24.145 21.1552C24.145 20.2012 23.7522 19.7727 22.4208 19.2881Z",
    fill: "#001722"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5122 19.9921C24.5122 21.7521 25.8947 23.1193 27.6751 23.1193C28.1801 23.1193 28.6086 23.0223 29.1392 22.7673V21.395C28.6698 21.8643 28.2566 22.048 27.7312 22.048C26.5579 22.048 25.7212 21.196 25.7212 19.9819C25.7212 18.8341 26.5834 17.9261 27.6802 17.9261C28.2362 17.9261 28.6596 18.125 29.1443 18.5994V17.2271C28.6341 16.967 28.2107 16.8599 27.7057 16.8599C25.9355 16.8599 24.5173 18.2525 24.5173 19.9921H24.5122Z",
    fill: "#001722"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5972 21.0177L37.0004 16.9927H35.7251L38.2656 23.1348H38.893L41.4846 16.9927H40.2143L38.5972 21.0177Z",
    fill: "#001722"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0151 22.9817H45.3259V21.9665H43.1783V20.3494H45.2443V19.3393H43.1783V18.0079H45.3259V16.9927H42.0151V22.9817Z",
    fill: "#001722"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9477 18.7626C49.9477 17.6403 49.1774 16.9976 47.8307 16.9976H46.0962V22.9866H47.2644V20.5787H47.4175L49.0346 22.9866H50.4681L48.5806 20.4614C49.4631 20.2829 49.9477 19.6809 49.9477 18.7626ZM47.6062 19.7523H47.2644V17.9362H47.6215C48.351 17.9362 48.7438 18.2423 48.7438 18.8238C48.7438 19.4054 48.351 19.7472 47.6011 19.7472L47.6062 19.7523Z",
    fill: "#001722"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7743 17.4416C50.7743 17.3344 50.7029 17.2783 50.5753 17.2783H50.407V17.8089H50.5345V17.6048L50.6824 17.8089H50.8406L50.6672 17.5895C50.7386 17.5691 50.7794 17.5181 50.7794 17.4416H50.7743ZM50.5549 17.513H50.5345V17.3752H50.5549C50.6161 17.3752 50.6518 17.3957 50.6518 17.4416C50.6518 17.4875 50.6212 17.513 50.5549 17.513Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6007 17.0791C50.3457 17.0791 50.1416 17.2832 50.1416 17.5382C50.1416 17.7933 50.3457 17.9973 50.6007 17.9973C50.8558 17.9973 51.0548 17.7882 51.0548 17.5382C51.0548 17.2883 50.8507 17.0791 50.6007 17.0791ZM50.6007 17.9157C50.3967 17.9157 50.2335 17.7474 50.2335 17.5382C50.2335 17.3291 50.3967 17.1607 50.6007 17.1607C50.8048 17.1607 50.9629 17.3291 50.9629 17.5382C50.9629 17.7474 50.7997 17.9157 50.6007 17.9157Z",
    fill: "#231F20"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4583_263182",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7714 34.3016) scale(3.15266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FEE8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDDBBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FAC496"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F7A55F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F48120"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.043bbaf2e96cf9d1ed326e0e87674d94.svg";
export { ForwardRef as ReactComponent };